
export class ReclamacionModel {

    ID: number;
    tasacionID: number;
    actuacionRealizada: string;
    detalle: string;
    fechaInicio: Date;
    fechaFin: Date;
    solucionReclamacion: string;

    public constructor(){
        this.ID = 0;
        this.tasacionID = 0;
        this.fechaInicio = null;
        this.fechaFin = null;
        this.solucionReclamacion = '';
        this.actuacionRealizada = '';
        this.detalle = '';
    }
}